import React from 'react';
import HMIS from '../images/HIMS.png';
import NFPA from '../images/NFPA.png';

export function DocumentProperties(props) {
    let properties = [];
    if (props.selectedDoc.documentProperties) {
        if (props.selectedDoc.documentProperties && props.selectedDoc.documentProperties.physicalProperties && props.selectedDoc.documentProperties.physicalProperties.length > 0) {
            properties.push({
                SortOrder: 1, propsHtml:
                    < div ><hr style={{ borderTop: "1px solid #bbb" }} />
                        <h4 style={{ paddingLeft: "20px" }} className="phraseSubHeader">{props.localizations.physicalProperties}</h4>
                        {props.selectedDoc.documentProperties.physicalProperties.sort((a, b) => a.sortOrder - b.sortOrder).map((props3, idx) =>
                            <div key={"phraseHtml" + idx}>
                                <h4 style={{ paddingLeft: "40px" }} className="phraseValueHeader">{props.localizations[props3.propertyName]}:</h4>
                                <div style={{ display: "inline-block", width: "50%", verticalAlign: "text-top", whiteSpace: "pre-line" }}>{props3.propertyValue}</div>
                            </div>
                        )}
                    </div >
            });
        }

        if (props.selectedDoc.documentProperties && props.selectedDoc.documentProperties.nfpaProperties && props.selectedDoc.documentProperties.nfpaProperties.length > 0) {
            var nfpaFlameobj = props.selectedDoc.documentProperties.nfpaProperties.find(x => x.propertyName === "Flammability");
            var nfpaFlame = "";
            if (nfpaFlameobj && nfpaFlameobj.propertyValue)
                nfpaFlame = nfpaFlameobj.propertyValue.substring(0, 1);
            var nfpaHealthobj = props.selectedDoc.documentProperties.nfpaProperties.find(x => x.propertyName === "Health");
            var nfpaHealth = "";
            if (nfpaHealthobj && nfpaHealthobj.propertyValue)
                nfpaHealth = nfpaHealthobj.propertyValue.substring(0, 1);
            var nfpaInstabilityobj = props.selectedDoc.documentProperties.nfpaProperties.find(x => x.propertyName === "Instability");
            var nfpaInstability = "";
            if (nfpaInstabilityobj && nfpaInstabilityobj.propertyValue)
                nfpaInstability = nfpaInstabilityobj.propertyValue.substring(0, 1);
            var nfpaSpecialobj = props.selectedDoc.documentProperties.nfpaProperties.find(x => x.propertyName === "Special");
            var nfpaSpecial = "";
            if (nfpaSpecialobj && nfpaSpecialobj.propertyValue)
                nfpaSpecial = nfpaSpecialobj.propertyValue.substring(0, 2);
            properties.push({
                SortOrder: 2, propsHtml:
                    <div><hr style={{ borderTop: "1px solid #bbb" }} />
                        <h4 className="phraseSubHeader">{props.localizations.nfpaProperties}</h4>
                        <div className="row DocDetailsRow">
                            <div className="col-6">
                                <div className="Hazardslogo" >
                                    <img id="nfpa" src={NFPA} alt={props.localizations.nfpaProperties} className="content-image img-thumbnail rounded" />
                                    <div className="nfpaFlame"><b>{nfpaFlame}</b></div>
                                    <div className="nfpaHealth"><b>{nfpaHealth}</b></div>
                                    <div className="nfpaInstability"><b>{nfpaInstability}</b></div>
                                    <div className="nfpaSpecial"><b>{nfpaSpecial}</b></div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="row">
                                    {props.selectedDoc.documentProperties.nfpaProperties.sort((a, b) => a.sortOrder - b.sortOrder).map((props3, idx) =>
                                        <div key={"nfpaHtml" + idx}>
                                            <div className="col-4" key={idx + "nfpatitle"} >
                                                <p style={{ color: "#0000ff", fontSize: "14px", fontWeight: "500" }}>{props.localizations[props3.propertyName]}:</p>
                                            </div>
                                            <div className="col-8 valueField" key={idx + "nfpavalue"} >
                                                <p style={{ color: "#2b2d42", fontFamily: "Inter" }}>
                                                    <span className="propDiv">{props3.propertyValue}</span>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
            });
        }

        if (props.selectedDoc.documentProperties && props.selectedDoc.documentProperties.hmisProperties && props.selectedDoc.documentProperties.hmisProperties.length > 0) {
            var hmisFlameobj = props.selectedDoc.documentProperties.hmisProperties.find(x => x.propertyName === "Flammability");
            var hmisFlame = "";
            if (hmisFlameobj && hmisFlameobj.propertyValue)
                hmisFlame = hmisFlameobj.propertyValue.substring(0, 1);
            var hmisHealthobj = props.selectedDoc.documentProperties.hmisProperties.find(x => x.propertyName === "Health");
            var hmisHealth = "";
            if (hmisHealthobj && hmisHealthobj.propertyValue)
                hmisHealth = hmisHealthobj.propertyValue.substring(0, 1);
            var hmisPHobj = props.selectedDoc.documentProperties.hmisProperties.find(x => x.propertyName === "PhysicalHazard");
            var hmisPH = "";
            if (hmisPHobj && hmisPHobj.propertyValue)
                hmisPH = hmisPHobj.propertyValue.substring(0, 1);
            var hmisPPEobj = props.selectedDoc.documentProperties.hmisProperties.find(x => x.propertyName === "PPE");
            var hmisPPE = "";
            if (hmisPPEobj)
                hmisPPE = hmisPPEobj.propertyValue.substring(0, 20);
            var hmisCronicobj = props.selectedDoc.documentProperties.hmisProperties.find(x => x.propertyName === "Chronic");
            var hmisCronic = "";
            if (hmisCronicobj && hmisCronicobj.propertyValue)
                hmisCronic = hmisCronicobj.propertyValue.substring(0, 1);
            properties.push({
                SortOrder: 3, propsHtml:
                    <div><hr style={{ borderTop: "1px solid #bbb" }} />
                        <h4 className="phraseSubHeader">{props.localizations.hmisProperties}</h4>
                        <div className="row DocDetailsRow">
                            <div className="col-6">
                                <div className="Hazardslogo" >
                                    <img id="hmis" src={HMIS} alt={props.localizations.hmisProperties} className="content-image img-thumbnail rounded" />
                                    <div className="hmisFlame"><b>{hmisFlame}</b></div>
                                    <div className="hmisHealth"><b>{hmisHealth}</b></div>
                                    <div className="hmisPH"><b>{hmisPH}</b></div>
                                    <div className="hmisPPE"><b>{hmisPPE}</b></div>
                                    <div className="hmisCronic"><b>{hmisCronic}</b></div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="row">
                                    {props.selectedDoc.documentProperties.hmisProperties.sort((a, b) => a.sortOrder - b.sortOrder).map((props3, idx) =>
                                        <div key={"hmisHtml" + idx}>
                                            <div className="col-4" key={idx + "hmistitle"} >
                                                <p style={{ color: "#0000ff", fontSize: "14px", fontWeight: "500" }}>{props.localizations[props3.propertyName]}:</p>
                                            </div>
                                            <div className="col-8 valueField" key={idx + "hmisValue"} >
                                                <p style={{ color: "#2b2d42", fontFamily: "Inter" }}>
                                                    <span className="propDiv">{props3.propertyValue}</span>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
            });
        }
    }
    return <>
        {properties.sort((a, b) => a.SortOrder - b.SortOrder).map((item, idx) =>
            <div key={"propsHtml" + idx}>
                {item.propsHtml}
            </div>
        )}
    </>;
}